// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","tabTrigger":"_1LXpu","opened":"_3-R6-"};